module.exports = __webpack_public_path__ + "static/media/kzvb_wallpaper.e9c368ee.jpg";